import groq from 'groq'

import { metadata } from '../../projections/metadata.js'
import { footer } from '../../projections/footer.js'
// ******************** //
import { header } from './sections/header.js'
import { benefits } from './sections/benefits.js'
import { team } from './sections/team.js'
import { tagline } from './sections/tagline.js'
import { challenge } from './sections/challenge.js'
import { struggles } from './sections/struggles.js'
import { introduction } from './sections/introduction.js'
import { capabilities } from './sections/capabilities.js'
import { insights } from './sections/insights.js'

export function landing() {
	return groq`*[_type == 'page.landing'][0]{
    _type,
    "metadata": metadata{...${metadata()}},
    "footer":{...${footer()}},
    "sections": sections[] {
      _type,
      _type == 'header' => {${header}},
      _type == 'benefits' => {${benefits}},
      _type == 'challenge' => {${challenge}},
      _type == 'struggles' => {${struggles}},
      _type == 'introduction' => {${introduction}},
      _type == 'capabilities' => {${capabilities}},
      _type == 'insights' => {${insights}},
      _type == 'team' => {${team}},
      _type == 'tagline' => {${tagline}},
     }
  }
`
}
